import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MediaRecording } from 'src/app/models/media-recording.model';

@Pipe({
  name: 'mediaRecordingProcessingOnServer',
  standalone: true,
  pure: true,
})
@Injectable({ providedIn: 'root' })
export class MediaRecordingProcessingOnServerPipe implements PipeTransform {
  transform(recording: MediaRecording | null | undefined): boolean {
    if (recording === null || recording === undefined) {
      return false;
    }

    return this.isMediaRecordingProcessingOnServer(recording);
  }

  private isMediaRecordingProcessingOnServer(recording: MediaRecording): boolean {
    return this.isMediaRecordingQueuedForServerProcessing(recording) || this.isMediaRecordingActivelyProcessingOnServer(recording);
  }

  private isMediaRecordingQueuedForServerProcessing(recording: MediaRecording): boolean {
    return recording.server_processing_status === 'queued';
  }

  private isMediaRecordingActivelyProcessingOnServer(recording: MediaRecording): boolean {
    return recording.server_processing_status === 'processing' || recording.youtube_upload_status === 'uploading';
  }
}
